module.exports = __webpack_public_path__ + "img/levelup-icon-invoice.a54df939.svg";